module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-test-c3af57a68d45b4a603b45228a6965b68.png";